export { LinkCommand } from './link.cmd';
